// src/service/ragSearch.js
const RAG_BASE =
  process.env.REACT_APP_RAG_API || "https://search.insidechassidus.org";

export class RagError extends Error {
  constructor(message, { rateLimited = false, status } = {}) {
    super(message);
    this.name = "RagError";
    this.rateLimited = rateLimited;
    this.status = status;
  }
}

export async function ragAsk(q) {
  const res = await fetch(`${RAG_BASE}/ask?q=${encodeURIComponent(q)}`);
  if (res.status === 429) {
    throw new RagError("rate_limited", { rateLimited: true, status: 429 });
  }
  if (!res.ok) {
    throw new RagError("request_failed", { status: res.status });
  }
  return res.json();
}

export function sendEvent(body) {
  try {
    fetch(`${RAG_BASE}/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* best-effort analytics */
  }
}

export async function ragRecurring(type, date) {
  const params = new URLSearchParams({ type });
  if (date) params.set("date", date);
  const res = await fetch(`${RAG_BASE}/recurring?${params.toString()}`);
  if (!res.ok) {
    throw new RagError("recurring_failed", { status: res.status });
  }
  return res.json();
}

export async function ragSimilar(classId, limit) {
  const params = new URLSearchParams({ class_id: String(classId) });
  if (limit) params.set("limit", String(limit));
  const res = await fetch(`${RAG_BASE}/similar?${params.toString()}`);
  if (res.status === 404) return null; // class has no profile — caller hides the rail
  if (!res.ok) {
    throw new RagError("similar_failed", { status: res.status });
  }
  return res.json();
}

export function streamAnswer(q, { onToken, onDone, onError, flavor } = {}) {
  const flavorParam = flavor ? `&flavor=${encodeURIComponent(flavor)}` : "";
  const es = new EventSource(`${RAG_BASE}/answer?q=${encodeURIComponent(q)}${flavorParam}`);
  es.addEventListener("token", (e) => {
    if (onToken) onToken(e.data);
  });
  es.addEventListener("done", (e) => {
    es.close();
    if (onDone) onDone(JSON.parse(e.data));
  });
  es.addEventListener("error", (e) => {
    es.close();
    if (onError) onError(e);
  });
  return () => es.close();
}

export async function ragConcept(slug, limit = 30) {
  const res = await fetch(
    `${RAG_BASE}/concept/${encodeURIComponent(slug)}?limit=${limit}`
  );
  if (!res.ok) {
    throw new RagError("request_failed", { status: res.status });
  }
  return res.json();
}
